import React from 'react';
import classNames from 'classnames';

type SidebarLayoutProps = {
  sidebar: React.ReactNode;
  className?: string;
};

export const SidebarLayout: React.FC<SidebarLayoutProps> = ({
  sidebar,
  children,
  className,
}) => (
  <div className="flex flex-grow overflow-hidden">
    {sidebar}

    <main className="flex-grow overflow-auto">
      <div className={classNames(className, 'max-w-7xl h-full mx-auto px-5')}>
        {children}
      </div>
    </main>
  </div>
);
